import gql from "graphql-tag";

export const MY_ORGANIZATION_MApp_PULSE_CHECK = gql`
  query myOrganizationMAppPulseCheck {
    myOrganizationMAppPulseCheck
  }
`;
